export default {
  protocol: {},
  history: [],
  protocolItems: [],
  timeline: [],
}
